import { render, staticRenderFns } from "./MaterialsPage.vue?vue&type=template&id=36b6a15b&scoped=true"
import script from "./MaterialsPage.vue?vue&type=script&lang=ts"
export * from "./MaterialsPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialsPage.vue?vue&type=style&index=0&id=36b6a15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b6a15b",
  null
  
)

export default component.exports